import { SPACING_PRIMITIVE as x } from "./index.es2449.js";
const s = {
  /**
   * 2px spacing value.
   * Used for the smallest spacing between elements.
   */
  xxxs: x[2],
  /**
   * 4px spacing value.
   * Used for very small spacing between elements.
   */
  xxs: x[4],
  /**
   * 6px spacing value.
   * Used for extra small spacing between elements.
   */
  xs: x[6],
  /**
   * 8px spacing value.
   * Used for small spacing between elements.
   */
  s: x[8],
  /**
   * 12px spacing value.
   * Used for medium spacing between elements.
   */
  md: x[12],
  /**
   * 16px spacing value.
   * Used for large spacing between elements.
   */
  lg: x[16],
  /**
   * 24px spacing value.
   * Used for extra large spacing between elements.
   */
  xl: x[24],
  /**
   * 32px spacing value.
   * Used for 2x extra large spacing between elements.
   */
  "2xl": x[32],
  /**
   * 40px spacing value.
   * Used for 3x extra large spacing between elements.
   */
  "3xl": x[40],
  /**
   * 48px spacing value.
   * Used for 4x extra large spacing between elements.
   */
  "4xl": x[48]
};
export {
  s as SPACINGS
};
//# sourceMappingURL=index.es705.js.map
